import Icon from '../../../icons/Icon';
import React from 'react';

const SarDefaultInfoButton = ({ hasError = false, onStopPropagation }: Props) => (
  <button type={'button'} className={'w-3 flex items-center justify-center rounded-full'} aria-label={'Information'} onClick={onStopPropagation}>
    <Icon
      icon={'kyc_informationicon'}
      className={`text-f-black-2 hover:opacity-50 opacity-100 transition-opacity duration-200 ${hasError ? 'text-f-red-1' : ''}`}
    />
  </button>
);

export default SarDefaultInfoButton;

interface Props {
  onStopPropagation: (event: React.MouseEvent<HTMLButtonElement>) => void;
  hasError?: boolean;
}
